export const SAVE_USER = 'SAVE_USER';
export const saveUser = (user) => ({
  type: SAVE_USER,
  payload: { user },
});
